export const TEMPLATES = [
  {
    id: 'tpl-01',
    category: 'PORTFOLIO',
    title: 'ARISTIDE.INSPIRED',
    desc: 'Portfolio 2026',
    img: '/templates/tpl-01/src/images/silence.webp',
    subProjects: [
      {
        id: 1,
        title: 'SILENCE',
        category: 'Photography',
        year: '2024',
        image:
          'https://images.unsplash.com/photo-1494438639946-1ebd1d20bf85?q=80&w=2067',
        description:
          '공간의 정적과 빛의 흐름을 포착하여 시각적 고요함을 선사합니다.',
      },
      {
        id: 2,
        title: 'STRUCTURE',
        category: 'Architecture',
        year: '2024',
        image:
          'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070',
        description:
          '도시의 골조와 기하학적 반복이 만들어내는 리듬을 기록합니다.',
      },
      {
        id: 3,
        title: 'ELEMENT',
        category: 'Art Direction',
        year: '2023',
        image:
          'https://images.unsplash.com/photo-1505330622279-bf7d7fc918f4?q=80&w=2070',
        description:
          '브랜드의 핵심 요소를 해체하고 재구성하여 새로운 내러티브를 제안합니다.',
      },
      // 🚀 4번: ORGANIC (자연의 유기적 곡선과 질감)
      {
        id: 4,
        title: 'ORGANIC',
        category: 'Digital Art',
        year: '2024',
        image:
          'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?q=80&w=2070',
        description:
          '기술과 자연의 경계에서 탄생한 유기적인 형태의 디지털 조각들을 아카이빙합니다.',
      },
      // 🚀 5번: BEYOND (우주, 확장, 미지의 공간)
      {
        id: 5,
        title: 'BEYOND',
        category: 'Exhibition',
        year: '2025',
        image:
          'https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?q=80&w=2072',
        description:
          '물리적 공간을 넘어선 디지털 경험의 확장성을 실험한 전시 프로젝트입니다.',
      },
    ],
  },
  {
    id: 'tpl-cafe24-01', // 카페24 템플릿 ID
    category: 'COMMERCE',
    title: 'CAFE24 PREMIUM',
    desc: '카페24 기반 쇼핑몰 템플릿',
    img: 'https://dcenter-img.cafe24.com/d/product/2026/02/10/uwjjoshyzz0ilgm41qw0cqt2bhsob48y.png', // 카페24 업로드 이미지
    link: 'https://d.cafe24.com/product/product_detail?productCode=PTMD867736',
    isExternal: true // 외부 링크 여부 체크용
  }
];
